import { isQubictronLocHostname } from "@qubictron/url";
import { Assets, resolveBackofficeOrigin } from "@qubictron/url/client";

export const appHash = __DEV__ ? new Date().getTime().toString() : __APP_VERSION__;

export const assets = new Assets({
  appFolder: __APP_FOLDER__,
  hash: appHash,
  originResolverCallbackMap: {
    localhost: () => ({ url: __APP_ORIGIN__ }),
    loc: () => ({ url: window.location.origin }),
  },
});

export const STATIC_IMAGES = ((): string => {
  const location = window.location.href;

  if (location.includes("local.qubictron.com")) {
    return "https://local.qubictron.com:3000/packages/auth-package/static/images";
  }
  if (isQubictronLocHostname(window.location.hostname)) {
    return `${window.location.origin}/packages/auth-package/static/images`;
  }

  return "https://apps.qubictron.com/packages/auth-package/static/images";
})();

export const APP_STYLESHEET_HREF = assets.css.appBundleBuilder({ isPackageAsApp: true }).build();
export const APP_FONTS_STYLESHEET_HREF = assets.css.fonts.bundleBuilder().build();
export const APP_FONTS_REGISTER_STYLESHEET_HREF = assets.css.fonts.bundleRegisterBuilder().build();

export const GOOGLE_CLIENT_URL = `${resolveBackofficeOrigin()}/auth/google/redirect`;
export const GITHUB_CLIENT_URL = `${resolveBackofficeOrigin()}/auth/github/redirect`;
